import React from 'react';
import { render } from 'react-dom';
import { Provider as Redux } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import createStore from './store';

import './index.scss';
import App from './app';
import isBrowser from './utils/isBrowser';

const store = createStore();

const element = document.getElementById('root');

element.innerHTML = `
    <div class="view-home">
        <div class="loader">
            <div class="spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
`;

if (isBrowser && (process.env.REACT_APP_ENV === 'development' || process.env.REACT_APP_ENV === 'staging')) {
  window.version = process.env.REACT_APP_VERSION;
}

render(
  <Redux store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Redux>,
  element,
);
